// Lightweight inline SVG sparkline. No external lib.

export default function Sparkline({
  data,
  color = "#2563eb",
  height = 36,
  className = "",
  testId,
}) {
  if (!data || data.length < 2) return null;
  const w = 120;
  const h = height;
  const pad = 2;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const points = data.map((v, i) => {
    const x = pad + (i / (data.length - 1)) * (w - 2 * pad);
    const y = h - pad - ((v - min) / range) * (h - 2 * pad);
    return [x, y];
  });
  const lineD = points
    .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`)
    .join(" ");
  const lastX = points[points.length - 1][0];
  const firstX = points[0][0];
  const areaD = `${lineD} L${lastX.toFixed(1)},${h - pad} L${firstX.toFixed(1)},${h - pad} Z`;
  const lastPoint = points[points.length - 1];

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      className={`w-full ${className}`}
      preserveAspectRatio="none"
      style={{ height }}
      data-testid={testId}
    >
      <path d={areaD} fill={color} fillOpacity={0.1} />
      <path
        d={lineD}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={lastPoint[0]} cy={lastPoint[1]} r={2} fill={color} />
    </svg>
  );
}
